module.exports = __webpack_public_path__ + "static/media/tt.dc98b6df.png";